module.exports = __webpack_public_path__ + "static/media/gryphon_brent_comber_wood_texture.3f98c4be.jpg";